import { render } from "./500.vue?vue&type=template&id=76f8fa73&scoped=true&ts=true"
import script from "./500.vue?vue&type=script&lang=ts"
export * from "./500.vue?vue&type=script&lang=ts"

import "./500.vue?vue&type=style&index=0&id=76f8fa73&scoped=true&lang=css"

import exportComponent from "E:\\project\\ale\\建大车辆入校预约\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f8fa73"]])

export default __exports__